import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=31213e24&scoped=true&lang=html&"
import script from "./Category.vue?vue&type=script&lang=ts&"
export * from "./Category.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31213e24",
  null
  
)

export default component.exports